(function ($, app) {

	var globalSettings = {},
		u = app.cookie.get('u'),
        settings = app.cookie.getUserSettings();

	$.extend(globalSettings, $('[id$="siteData"]').data('settings'));
	$.extend(globalSettings, settings);
	app.cookie.domain = globalSettings.Acd;
	if (!app.isGuid(u)) {
		u = $('[id$="siteData"]').data('u');
        app.cookie.set('u', u, { expires: 365 });
	}
	globalSettings.u = u;
	$('[id$="siteData"]').data('settings', '');
	if (globalSettings['ImageServerURL']) {
		globalSettings.ImageServerURL = globalSettings.ImageServerURL.replace(/http:|https:/, location.protocol);
		globalSettings.SecureImageServerURL = globalSettings['ImageServerURL'].replace(/http:\/\//, 'https://');
	}
	globalSettings.XT = parseInt(app.cookie.get('xt')) || 0;

	app.GlobalSettings = globalSettings;

})(jQuery, app);